import { render } from "./useinfo.vue?vue&type=template&id=1338af6c&scoped=true&ts=true"
import script from "./useinfo.vue?vue&type=script&lang=ts"
export * from "./useinfo.vue?vue&type=script&lang=ts"

import "./useinfo.vue?vue&type=style&index=0&id=1338af6c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/vars.autocall.ai/vars.autocall.ai/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1338af6c"]])

export default __exports__